import React, { Fragment, useState } from "react";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import "./App.css";
import "./index.css";
import $ from "jquery";
import DOMPurify from "dompurify";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

import {
  SearchProvider,
  SearchBox,
  Results,
  Paging,
  PagingInfo,
  WithSearch,
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";
import ResultView from "./ResultView";

const lang =
  $(".languagePicker #dropdownLanguagePicker")?.text().trim("") || "עב";
const tran = require(`./translate/${lang}.json`);

const connector = new AppSearchAPIConnector({
  searchKey: $('meta[name="elasticPublicKey"]').attr("content")
    || "search-t72uzb4fexzo1x73hphs3wz1",
  engineName: $('meta[name="elasticBankEngine"]').attr("content")
    || "mizrahisearch",
  endpointBase: $('meta[name="elasticBaseUrl"]').attr("content")
    || "https://mizrahisearchapp.ent.eu-central-1.aws.cloud.es.io"
});

export default function App() {
  const callKey = $('meta[name="searchuikey"]').attr("content");
  const [siteEngineKey, setSiteEngineKey] = useState(callKey);
  const siteLanguageMeta = $('meta[name="siteLanguage"]').attr("content");
  const [siteLanguage, setSiteLanguage] = useState(siteLanguageMeta);
  const siteDomainMeta = $('meta[name="siteDomain"]').attr("content");
  const [siteDomain, setSiteDomain] = useState(siteDomainMeta);

  const searchFilters = [];
  if (siteDomain) {
    searchFilters.push({ field: "url_host", values: [siteDomain] });
  }

  return (
    <SearchProvider
      config={{
        apiConnector: connector,
        initialState: { resultsPerPage: 10 },
        searchQuery: {
          search_fields: { title: {} },
          result_fields: {
            title: { raw: {}, snippet: { size: 100, fallback: true } },
            url:   { raw: {} },
            url_host: { raw: {} },
            meta_description: { snippet: { size: 90, fallback: true }, raw: {} }
          },
          filters: searchFilters.length > 0 ? searchFilters : undefined
          },
          autocompleteQuery: {
            results: {
              result_fields: {
                title: { snippet: { size: 100, fallback: true } },
                url:   { raw: {} }
              },
              filters: searchFilters.length > 0 ? searchFilters : undefined
            }
          }
          }}
        >
          <WithSearch mapContextToProps={({ wasSearched }) => ({ wasSearched })}>
          {({ wasSearched }) => {
          return (
            <div className="App">
              <Layout
                header={
                  <SearchBox
                    autocompleteResults={{
                      titleField: "title",
                      urlField: "url",
                      linkTarget: "_blank"
                    }}
                    autocompleteView={({ autocompletedResults, getItemProps, getMenuProps }) => (
                      <div {...getMenuProps({ className: "sui-search-box__autocomplete-container" })}>
                        {autocompletedResults && autocompletedResults.length > 0 && (
                          <ul className="sui-search-box__results-list">
                            {autocompletedResults.filter((result) => {
                              try {
                                const u = new URL(String(result?.url?.raw || ""), window.location.origin);
                                return /^https?:$/i.test(u.protocol) &&
                                  (!siteDomain || u.hostname === siteDomain || u.hostname === window.location.hostname);
                              } catch { return false; }
                            }).map((result, i) => {
                              const titleHtml = DOMPurify.sanitize(
                                result?.title?.snippet ?? result?.title?.raw ?? "",
                                { ALLOWED_TAGS: ["em", "b", "strong", "mark"] }
                              );
                              const href = new URL(String(result.url.raw), window.location.origin).toString();
                              return (
                                <li key={result?.id?.raw || i} {...getItemProps({ index: i, item: result })}>
                                  <a
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    dangerouslySetInnerHTML={{ __html: titleHtml }}
                                  />
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                    )}
                    onSelectAutocomplete={(selection, { completeSuggestion }) => {
                      if (selection?.suggestion) {
                        completeSuggestion(selection.suggestion);
                      }
                      // URL navigation is handled by the <a> tag in autocompleteView
                    }}
                    inputView={({
                      getAutocomplete,
                      getInputProps,
                      getButtonProps,
                    }) => (
                      <>
                        <div className="sui-search-box__wrapper">
                          <input
                            {...getInputProps({
                              placeholder: tran.search,
                            })}
                          />
                          {getAutocomplete()}
                        </div>
                        <input
                          {...getButtonProps({
                            value: "",
                          })}
                        />
                      </>
                    )}
                  />
                }
                bodyContent={
                  <Results
                    titleField="title"
                    urlField="url"
                    resultView={ResultView}
                  />
                }
                bodyHeader={
                  <React.Fragment>
                    {wasSearched && (
                      <PagingInfo
                        view={({ start, end, totalResults, searchTerm }) => (
                          <div className="paging-info">
                            {totalResults ? (
                              <Fragment></Fragment>
                            ) : (
                              <div className="noTotalResults">
                                <h2 className="searchNoResult">
                                  {tran.noSearchResult} "{searchTerm}"
                                </h2>
                              </div>
                            )}
                          </div>
                        )}
                      />
                    )}
                  </React.Fragment>
                }
                bodyFooter={<Paging resultsPerPage={10} />}
              />
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}
